import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { AuthState } from "../../context/AuthProvider";
import { API, Notify } from "../../utils";
import { MdEmail, MdLock, MdLogin, MdPerson, MdVisibility, MdVisibilityOff } from "react-icons/md";

const LoginPage = () => {
  const [showPassword, setShowPassword] = useState(false);
  const [credentials, setCredentials] = useState({
    email: "",
    password: "",
  });
  const [isLoading, setIsLoading] = useState(false);

  const navigate = useNavigate();
  const { setAuth } = AuthState();

  const handleCredentials = (e) => {
    setCredentials({ ...credentials, [e.target.name]: e.target.value });
  };

  const loginHandler = async (e) => {
    e.preventDefault();
    setIsLoading(true);

    if (!credentials.email || !credentials.password) {
      setIsLoading(false);
      return Notify("Please Fill all the Fields", "warn");
    }

    try {
      const response = await API.post("/api/auth/login", credentials);
      const data = response.data;

      if (data.success) {
        localStorage.setItem("auth", JSON.stringify(data));
        setAuth(data);
        setIsLoading(false);
        navigate("/");
        return Notify("Successfully logged in", "success");
      } else {
        setIsLoading(false);
        return Notify(data.error, "warn");
      }
    } catch (error) {
      setIsLoading(false);
      const errorMsg = error.response?.data?.error || "Internal server error";
      return Notify(errorMsg, "error");
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-slate-900 to-slate-800 p-6">
      <div className="w-full max-w-[450px] bg-white rounded-2xl shadow-2xl overflow-hidden animate-in fade-in zoom-in duration-500">
        <div className="bg-blue-600 p-8 text-white text-center">
          <div className="bg-white/20 w-16 h-16 rounded-2xl flex items-center justify-center mx-auto mb-4 backdrop-blur-md">
            <MdLogin className="w-8 h-8 text-white" />
          </div>
          <h1 className="text-2xl font-bold tracking-tight">Kaviraj Agencies</h1>
          <p className="text-blue-100 text-sm mt-1">Sign in to manage your bunk</p>
        </div>

        <form onSubmit={loginHandler} className="p-8 space-y-5">
          <div>
            <label className="text-[11px] font-bold text-gray-400 uppercase tracking-wider block mb-1.5 ml-1">Email Address</label>
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none transition-colors group-focus-within:text-blue-600 text-gray-400">
                <MdEmail className="w-5 h-5" />
              </div>
              <input
                type="email"
                name="email"
                required
                className="w-full pl-11 pr-4 py-3 bg-gray-50 border border-gray-100 rounded-xl outline-none focus:border-blue-500 focus:bg-white transition-all text-gray-700 text-sm"
                placeholder="name@example.com"
                value={credentials.email}
                onChange={handleCredentials}
              />
            </div>
          </div>

          <div>
            {/* <div className="flex justify-between items-center mb-1.5 ml-1">
              <label className="text-[11px] font-bold text-gray-400 uppercase tracking-wider block">Password</label>
              <Link to="/forgotPassword" size="sm" className="text-[11px] font-bold text-blue-600 hover:underline">Forgot password?</Link>
            </div> */}
            <div className="relative group">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none transition-colors group-focus-within:text-blue-600 text-gray-400">
                <MdLock className="w-5 h-5" />
              </div>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                required
                className="w-full pl-11 pr-4 py-3 bg-gray-50 border border-gray-100 rounded-xl outline-none focus:border-blue-500 focus:bg-white transition-all text-gray-700 text-sm"
                placeholder="Enter Password"
                value={credentials.password}
                onChange={handleCredentials}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                className="absolute inset-y-0 right-0 pr-3 flex items-center text-gray-400 hover:text-blue-600 transition-colors"
              >
                {showPassword ? (
                  <MdVisibilityOff className="w-5 h-5" />
                ) : (
                  <MdVisibility className="w-5 h-5" />
                )}
              </button>
            </div>
          </div>

          <button
            type="submit"
            disabled={isLoading}
            className="w-full bg-blue-600 hover:bg-blue-700 text-white font-bold py-3.5 rounded-xl shadow-lg shadow-blue-200 transition-all active:scale-95 disabled:opacity-70 disabled:active:scale-100 flex items-center justify-center space-x-2"
          >
            {isLoading ? (
              <div className="w-5 h-5 border-2 border-white/30 border-t-white rounded-full animate-spin"></div>
            ) : (
              <>
                <span>Sign In</span>
                <MdLogin className="w-5 h-5" />
              </>
            )}
          </button>
        </form>
      </div>
    </div>
  );
};

export default LoginPage;
